export default __webpack_public_path__ + "static/media/overnight.07acef44.svg";